"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var class_transformer_1 = require("class-transformer");
var UrlIdMapper_1 = require("../../utils/UrlIdMapper");
var MediaAsset_1 = require("./MediaAsset");
var ImageAsset_1 = require("./ImageAsset");
// eslint-disable-next-line import/prefer-default-export
var Episode = /** @class */ (function () {
    function Episode() {
    }
    Episode.createInstance = function (plainObject) {
        return class_transformer_1.plainToClass(Episode, plainObject);
    };
    Episode.createInstances = function (plainObjectArray) {
        return class_transformer_1.plainToClass(Episode, plainObjectArray);
    };
    Object.defineProperty(Episode.prototype, "id", {
        get: function () {
            return UrlIdMapper_1.urlToId(this.url);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Episode.prototype, "seasonId", {
        get: function () {
            return UrlIdMapper_1.urlToId(this.parentUrl);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        class_transformer_1.Type(function () { return ImageAsset_1.ImageAsset; })
    ], Episode.prototype, "images", void 0);
    __decorate([
        class_transformer_1.Type(function () { return MediaAsset_1.MediaAsset; })
    ], Episode.prototype, "mediaAssets", void 0);
    return Episode;
}());
exports.Episode = Episode;
//# sourceMappingURL=Episode.js.map